export default __webpack_public_path__ + "8fff3c64279de41484c57a78e83a2a62.png";